export enum PromptTabs {
  Home = "Home",
  AllPrompts = "AllPrompts",
  SavedPrompts = "SavedPrompts",
  GroupPrompts = "GroupPrompts",
  LikedPrompts = "LikedPrompts",
  BrowsePrompts = "BrowsePrompts",
  AgentPrompts = "AgentPrompts",
  SearchPrompts = "SearchPrompts",
  WorkplacePrompts = "WorkplacePrompts",
  MicrosoftPrompts = "MicrosoftPrompts",
  CombinedPrompts = "CombinedPrompts", //All prompts source. Used in v2 MOS app since AllPrompts in v1 is Microsoft prompts and we wanted to avoid regression of v1
}
